var map = {
	"./en/about.json": 9732,
	"./en/audience.json": 6921,
	"./en/contact.json": 5189,
	"./en/curriculum.json": 4612,
	"./en/footer.json": 8172,
	"./en/hero.json": 331,
	"./en/intro.json": 8203,
	"./en/menu.json": 2048,
	"./en/reviews.json": 4572,
	"./en/services.json": 8267,
	"./he/about.json": 48,
	"./he/audience.json": 4893,
	"./he/contact.json": 9737,
	"./he/curriculum.json": 4600,
	"./he/footer.json": 8128,
	"./he/hero.json": 4823,
	"./he/intro.json": 1415,
	"./he/menu.json": 348,
	"./he/reviews.json": 7072,
	"./he/services.json": 4671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;